package com.macrofocus.eflux.ui.layer

import com.macrofocus.common.selection.MutableSelection
import com.macrofocus.common.selection.MutableSingleSelection
import com.macrofocus.eflux.deckgl.toJSonArray
import com.macrofocus.eflux.network.lightning.LightningCluster
import deckgl.PolygonLayer
import js.objects.unsafeJso
import org.locationtech.jts.geom.Polygon
import kotlin.math.absoluteValue
import kotlin.math.max

fun createLightningClustersLayer(
    componentList: Array<LightningCluster>?,
    isCartographicZoomed: Boolean,
    probing: MutableSingleSelection<LightningCluster>?,
    selection: MutableSelection<LightningCluster>?

) : PolygonLayer<LightningCluster> {
    return PolygonLayer<LightningCluster>(unsafeJso {
        id = "lightning-clusters-layer"
        this.data = componentList

        visible = componentList != null

        opacity = 1.0
        asDynamic().positionFormat = "XY"
        asDynamic().getPolygon = { c: LightningCluster ->
            val array: Array<Array<Double>>? = (c.geometry as? Polygon?)?.toJSonArray()
            array
        }
        asDynamic().getFillColor = { c: LightningCluster ->
            if(c.type == "hull_trail") {
                val maxOpacity = 30
                val opacity = max(1, (maxOpacity * (1 - c.order.absoluteValue / 12.0)).toInt())
                arrayOf(240, 240, 200, opacity)
            } else if(c.type == "hull_projected") {
                arrayOf(255, 100, 100, 120)
            } else {
                arrayOf(253, 255, 180, 150)
            }
        }
        asDynamic().stroked = true
        asDynamic().getLineColor = { c: LightningCluster ->
            if(c.type == "hull_trail") {
                arrayOf(168, 168, 140)
            } else if(c.type == "hull_projected") {
                arrayOf(178, 70, 70)
            } else {
                arrayOf(139, 128, 0)
            }
        }
//        pickable = (probing != null && probing.isEnabled) ||(selection != null && selection.isEnabled)
        pickable = false
        autoHighlight = true
        highlightColor = if(isCartographicZoomed) arrayOf(253, 255, 180, 32) else arrayOf(253, 255, 180, 127)
        updateTriggers = unsafeJso {
            this.asDynamic().opacity = arrayOf(isCartographicZoomed)
            this.asDynamic().getFillColor = arrayOf(isCartographicZoomed)
            this.asDynamic().highlightColor = arrayOf(isCartographicZoomed)
        }
//        onHover = { info ->
//            val o = info.`object`
//            if (o != null) {
//                if (o is LightningCluster) {
//                    probing?.selected = o
//                } else {
//                    probing?.clearSelection()
//                }
//            } else {
//                probing?.clearSelection()
//            }
//        }
//        onClick = { info: dynamic ->
//            val o = info.`object`
//            if (o != null) {
//                if (o is LightningCluster) {
//                    selection?.setSelectedElement(o)
//                } else {
//                    selection?.clearSelection()
//                }
//            } else {
//                selection?.clearSelection()
//            }
//        }
    })
}
